import AirBnBFeaturedDestinationsContainer from '../../../../components/containers/AirBnBFeaturedDestinationsContainer';
import deepmerge from '../../../utils/deepmerge';
import preloadCustomProps from '../../../utils/preloads/preloadFeaturedListings';

const cmpConfig = {
  name: 'featured-listings',
  moduleId: 'em-cmp-lib-airmodules',
  staticAssetsHost: 'https://em-frontend-assets.airtrfx.com',
  version: 'NO_NEEDED',
  containerConfig: {
    settings: {
      instance: AirBnBFeaturedDestinationsContainer
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
